import * as types from './types';

function setAllPolicies(data) {
    return {
        payload: data,
        type: types.SET_ALL_POLICIES,
    };
}

function setPolicy(carrierCode, data) {
    return {
        meta: carrierCode,
        payload: data,
        type: types.SET_POLICY,
    };
}

export {
    setAllPolicies,
    setPolicy,
};
